import React, { useEffect, useState, useRef } from 'react'
import { logoutUser, submitUpdatePerfil } from '../actions'
import { withRouter } from 'react-router-dom'
import { Button, MenuItem, Popper, MenuList, Paper, Grow, ClickAwayListener } from '@material-ui/core'
import { connect } from 'react-redux'

import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import Dialog from '@material-ui/core/Dialog'
import DialogoPerfil from '../components/DialogoPerfil'

function LoginInfo (props) {
  const { username, color = null, roles } = props

  const [open, setOpen] = useState(false)
  const [openPerfil, setOpenPerfil] = useState(false)
  const anchorRef = useRef(null)
  const prevOpen = useRef(open)

  const handleClosePerfil = () => {
    setOpenPerfil(false)
  }

  const handleSubmit = async () => {
    props.submitUpdatePerfil(username, rolDeCupo)
    setOpenPerfil(false)
  }

  const handleLogoutClick = () => {
    props.logoutUser(props.history)
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  const handlePerfil = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpenPerfil(true)
  }

  function handleListKeyDown (event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }
    prevOpen.current = open
  }, [open])

  const rol = roles.filter((r) => r === 'BALANCEROCAMIONES')
  const showMessage = rol.length > 0 && (username !== 'brutochofer' && username !== 'destarechofer')
  const rolDeCupo = roles.filter((r) => r === 'CARGADOR' || r === 'CORREDOR')

  return (
    <>
      { username
        ? <div>
          <Dialog
            open={openPerfil}
            onClose={handleClosePerfil}
            fullWidth
            maxWidth='sm'>
            <DialogoPerfil handleClose={handleClosePerfil} handleSubmit={handleSubmit} rolDeCupo={rolDeCupo} />
          </Dialog>
          {showMessage
            ? <p style={{
              border: '2px solid',
              borderColor: 'white',
              borderRadius: '8px',
              margin: '1% 0 0 0',
              padding: '8px',
              color: 'white'
            }}
            >
                  Al finalizar recuerde cerrar sesión
            </p>
            : <></>
          }
          <Button
            ref={anchorRef}
            aria-haspopup='true'
            onClick={handleToggle}
            style={{ color: color || '#000000de', textTransform: 'lowercase' }}
          >
            <AccountCircleIcon style={{ color: color || '#000000de', margin: '0 8px 0 0' }} />
            {username}
            <KeyboardArrowDownIcon stlye={{ color: color || '#000000de', margin: '0 0 0 8px' }} />
          </Button>
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem={open} id='menu-list-grow' onKeyDown={handleListKeyDown}>
                      {/* <MenuItem onClick={handleClose}>
                        <Link to='/ayuda' style={{ textDecoration: 'none', color: COLORES.grey.dark }}> Ayuda </Link>
                      </MenuItem> */}
                      <MenuItem onClick={handlePerfil}> <AccountCircleIcon style={{ margin: '0 5px 0 0' }} /> Mi perfil </MenuItem>
                      <MenuItem onClick={handleLogoutClick}> <ExitToAppIcon style={{ margin: '0 5px 0 0' }} /> Cerrar sesión</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
        : <></>
      }
    </>

  )
}

const mapStateToProps = (state) => ({
  authenticated: state.auth.authenticated,
  username: state.auth.username,
  roles: state.auth.roles
})

const mapActionsToProps = {
  logoutUser,
  submitUpdatePerfil
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRouter(
  withRedux(LoginInfo)
)
